let prioritySeasons = {
 "categories":{
   "Chaussures":{
     "coef":0.5,
   },
   "Chemises et blouses":{
     "coef":0.5,
   },
   "Combinaisons":{
     "coef":0.5,
   },
    "Jeans":{
      "coef":0.5,
   },
    "Jupes":{
     "coef":0.8,
   },
    "Pantalons et pantacourts":{
     "coef":0.5,
   },
    "Pulls et gilets":{
     "coef":0.2,
   },
    "Robes":{
     "coef":0.5,
   },
    "Sacs":{
     "coef":0.5,
   },
    "Shorts et bermudas":{
     "coef":0.9,
   },
    "Tops et t-shirts":{
     "coef":0.6,
   },
    "Vestes et manteaux":{
     "coef":0.2,
   }
 }
}